import {NavList, TextField} from '@superweb/ui'
import {useI18n} from '@yandex-delivery/core/i18n'
import React from 'react'

import {type ZonesInfo} from '../../../../../../api'
import styleClasses from './classes.module.css'
import {useCitySearch, usePreparedCities} from './lib'

export type CitiesListProps = {
  zones: ZonesInfo
  country: string
}

export function CitiesList({country, zones}: CitiesListProps) {
  const i18n = useI18n()

  // Хук для маппинга городов в формат для NavList
  const {allCities, cityToNavListItem} = usePreparedCities({zones, country})

  const {inputValue, onInputChange, searchValue, filteredCities} = useCitySearch({
    zones,
    cityToNavListItem,
  })

  return (
    <div className={styleClasses.citiesListWrapper}>
      <TextField
        label={i18n('tariffs-v3.cities-list.input.placeholder', 'Поиск города')}
        onChange={onInputChange}
        state={{
          value: inputValue,
        }}
      />

      {searchValue ? (
        <NavList items={filteredCities} />
      ) : (
        // Города в groups сгруппированы по первой букве
        <NavList groups={allCities.others} items={allCities.frequent} />
      )}
    </div>
  )
}
